
export class ChannelStreamSettings {
  gang: boolean;

  constructor() {
    this.gang = false;
  }
}
